import { filter } from 'lodash';
import { createNamespacedHelpers } from 'vuex';

import {
  COLUMNS_WIDGET_TEMPLATES_TYPES,
  QUICK_ACTIONS_WIDGET_TEMPLATES_TYPES,
  MAX_LIMIT,
  WIDGET_TEMPLATES_TYPES,
} from '@/constants';

import { widgetColumnsToForm } from '@/helpers/entities/widget/column/form';
import { widgetQuickActionsToForm } from '@/helpers/entities/widget/quick-action/form';
import { widgetSortColumnsToForm } from '@/helpers/entities/widget/sort-column/form';

const { mapActions } = createNamespacedHelpers('widgetTemplate');

export const widgetTemplatesMixin = {
  data() {
    return {
      widgetTemplates: [],
      widgetTemplatesPending: false,
    };
  },
  mounted() {
    this.fetchList();
  },
  computed: {
    preparedWidgetTemplates() {
      return this.widgetTemplates.map((template) => {
        if (COLUMNS_WIDGET_TEMPLATES_TYPES.includes(template.type)) {
          return { ...template, columns: widgetColumnsToForm(template.columns) };
        }

        if (QUICK_ACTIONS_WIDGET_TEMPLATES_TYPES.includes(template.type)) {
          return { ...template, actions: widgetQuickActionsToForm(template.actions) };
        }

        if (WIDGET_TEMPLATES_TYPES.alarmSortColumns === template.type) {
          return { ...template, sort_columns: widgetSortColumnsToForm(template.sort_columns) };
        }

        return template;
      });
    },

    alarmColumnsWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.alarmColumns });
    },

    alarmSortColumnsWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.alarmSortColumns });
    },

    entityColumnsWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.entityColumns });
    },

    alarmMoreInfosWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.alarmMoreInfos });
    },

    alarmExportToPdfWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.alarmExportToPdf });
    },

    alarmQuickActionsWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.alarmQuickActions });
    },

    alarmMassQuickActionsWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.alarmMassQuickActions });
    },

    weatherItemWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.weatherItem });
    },

    weatherModalWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.weatherModal });
    },

    weatherEntityWidgetTemplates() {
      return filter(this.preparedWidgetTemplates, { type: WIDGET_TEMPLATES_TYPES.weatherEntity });
    },
  },
  methods: {
    ...mapActions({ fetchWidgetTemplatesListWithoutStore: 'fetchListWithoutStore' }),

    async fetchList() {
      try {
        this.widgetTemplatesPending = true;

        const { data } = await this.fetchWidgetTemplatesListWithoutStore({ params: { limit: MAX_LIMIT } });

        this.widgetTemplates = data;
      } catch (err) {
        console.warn(err);
      } finally {
        this.widgetTemplatesPending = false;
      }
    },
  },
};
